import { TableBody, TableRow, TableCell, Table, ButtonProps } from '@mui/material'
import { EFOtapAgentNetworkSchedulesRow } from './EFOtapAgentNetworkSchedulesRow'
import { MaxConcurrentSchedules, MaxConcurrentType } from './EFOtapAgentNetworkSchedules.model'
import styles from './EFOtapAgentNetworkSchedules.module.scss';

export function EFOtapAgentNetworkSchedules(
    {
      methods,
      agentNetworkIndex,
  }: Readonly<MaxConcurrentSchedules>
)
{
  const maxScheduleHoursLength = 24;
  const { getValues } = methods;

  const dayHours = Array.from({ length: maxScheduleHoursLength }, (_, i) =>
    `${String(i).padStart(2, '0')}:00`
  );

  const Days = [
    { key: 'sun', label: 'Sunday' },
    { key: 'mon', label: 'Monday' },
    { key: 'tue', label: 'Tuesday' },
    { key: 'wed', label: 'Wednesday' },
    { key: 'thu', label: 'Thursday' },
    { key: 'fri', label: 'Friday' },
    { key: 'sat', label: 'Saturday' },
  ] as const;

  const MaxConcurrentTypeInfo: Record<
    MaxConcurrentType,
    {
      color: ButtonProps['color'];
      title: string;
      value: number;
    }
  > = {
    [MaxConcurrentType.H]: {
      color: 'success',
      title: 'High concurrency',
      value: Number(getValues(`networks.${agentNetworkIndex}.high`) ?? 1),
    },
    [MaxConcurrentType.M]: {
      color: 'warning',
      title: 'Medium concurrency',
      value: Number(getValues(`networks.${agentNetworkIndex}.medium`) ?? 1),
    },
    [MaxConcurrentType.L]: {
      color: 'error',
      title: 'Low concurrency',
      value: Number(getValues(`networks.${agentNetworkIndex}.low`) ?? 1),
    },
  };
 
  return (
    <Table>
      <thead>
        <tr>
          <TableCell colSpan={ (maxScheduleHoursLength + 1) } className={ styles.tableTopEFOtapAgentNetworkSchedules }>
            <strong>Maximum Concurrency Schedule (UTC)</strong>
          </TableCell>
        </tr>
      </thead>
      <TableBody>
        <TableRow>
          <TableCell>
            <strong>Day / Hour</strong>
          </TableCell>
          { dayHours.map((hour: any, index: number) => (
            <TableCell key={ `${hour}` } className={ styles.tableCellEFOtapAgentNetworkSchedules }>
              <strong>{ hour }</strong>
            </TableCell>
          ))}
        </TableRow>
        {
          Days.map(({ key, label }) => (
            <EFOtapAgentNetworkSchedulesRow
              key={ key }
              day={ label }
              formPath={ `networks.${agentNetworkIndex}.${key}` }
              maxScheduleHoursLength={ maxScheduleHoursLength }
              methods={methods}
              maxConcurrentTypeInfo={MaxConcurrentTypeInfo}
          />
          ))
        }
      </TableBody>
      <tfoot>
        <tr>
          <td colSpan={ (maxScheduleHoursLength + 1) } className={ styles.tableBottomEFOtapAgentNetworkSchedules }>
          </td>
        </tr>
      </tfoot>
    </Table>
  )
}